export default __webpack_public_path__ + "static/media/books-61.e7607490.jpg";